import 'lazysizes';

import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
import focus from '@alpinejs/focus';
import intersect from '@alpinejs/intersect';
import persist from '@alpinejs/persist';
import { ValidationService } from 'aspnet-client-validation';

export function bootFrontend({ beforeStart } = {}) {
    Alpine.plugin(intersect);
    Alpine.plugin(persist);
    Alpine.plugin(focus);
    Alpine.plugin(collapse);

    if (typeof beforeStart === 'function') {
        beforeStart({ Alpine });
    }

    window.Alpine = Alpine;
    Alpine.start();

    const validationService = new ValidationService();
    validationService.bootstrap();
}
